import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api, { formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(loc.search || window.location.search || "");
    const code = params.get("code");
    const state = params.get("state");
    const error = params.get("error");

    // Clean URL immediately so the code/state isn't visible
    window.history.replaceState(null, "", "/auth/google/callback");

    if (error) {
      toast.error(`Google sign-in cancelled.`);
      nav("/login", { replace: true });
      return;
    }
    if (!code) {
      nav("/login", { replace: true });
      return;
    }

    const savedState = sessionStorage.getItem("g_state");
    if (!savedState || savedState !== state) {
      toast.error("Sign-in state mismatch. Please try again.");
      nav("/login", { replace: true });
      return;
    }
    sessionStorage.removeItem("g_state");

    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUri = window.location.origin + "/auth/google/callback";
    const next = sessionStorage.getItem("g_next") || "/dashboard";
    sessionStorage.removeItem("g_next");

    (async () => {
      try {
        const { data } = await api.post("/auth/google/exchange", {
          code,
          redirect_uri: redirectUri,
        });
        setUser(data);
        toast.success(`Welcome, ${data.name?.split(" ")[0] || "friend"}!`);
        nav(data.role === "admin" ? "/admin" : next, { replace: true });
      } catch (err) {
        toast.error(formatErr(err));
        nav("/login", { replace: true });
      }
    })();
  }, [loc.search, nav, setUser]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto mb-4 rounded-full border-4 border-[var(--ser-sand)] border-t-[var(--ser-primary)] animate-spin" />
        <p style={{ color: "var(--ser-text-muted)" }}>Completing sign-in…</p>
      </div>
    </div>
  );
}
